import React, { useRef } from "react"
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination } from 'swiper/modules'

import SliderButton from '../../../image/icons/slider-button.svg'
import { sendGAEvent } from "@utils/analytics"
import { GA_EVENTS } from "@utils/analytics/constants"

const CarouselBanner = ({data}) => {

  const navigationPrevRef = useRef(null)
  const navigationNextRef = useRef(null)

  const handleBannerClick = (type, title) => {
	sendGAEvent(GA_EVENTS.NAVIGATION_CLICK, {type: type, banner_title: title, queryName: 'hero banner'})
  }

  return (
    <React.Fragment>
      <div className="max-w-full mx-auto">
        <Swiper
          spaceBetween={0}
          slidesPerView={1}
          modules={[Navigation, Pagination]}
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = navigationPrevRef.current;
            swiper.params.navigation.nextEl = navigationNextRef.current;
          }}
          pagination={true}
          className="mySwiper"
          loop={true}
        >
          {
            data?.map((item, index) => {
      
              return (
                <SwiperSlide key={`banner-${item?.title}`}>
                  {/* <section className={`w-auto h-[525px] md:h-[480px] lg:h-[665px] max-h-[665px]`}> */}
                  <section className={`w-full h-auto relative`}>
                    <a 
						href={item?.url}
						onClick={() => handleBannerClick('mobile', item?.title)}
					>
						<img className="w-full h-auto object-fill block sm:hidden" src={`/.netlify/images?url=${item?.mobileImage ?? item?.image}`} alt={item?.altText} loading="lazy" />
					</a>

                    <a 
						href={item?.url}
						onClick={() => handleBannerClick('desktop', item?.title)}
					>
						<img className="w-full h-auto object-fill hidden sm:block" src={`/.netlify/images?url=${item?.image}`} alt={item?.altText} loading="lazy" />
					</a>
                 
                  </section>
                </SwiperSlide>
              );
            })
          }

          <div
            className="bg-white-800 text-black size-4 p-2 rounded cursor-pointer z-30 absolute top-[50%] bottom-[50%]"
            ref={navigationPrevRef}
          >
            <img className="absolute -top-5 w-11 h-11 max-w-11" src={SliderButton} alt='slide-left' />
          </div>

          <div
            className="bg-white-800 text-black size-4 p-2 rounded cursor-pointer z-30 absolute top-[50%] bottom-[50%] right-0"
            ref={navigationNextRef}
          >
            <img className="absolute -left-10 -top-5 w-11 h-11 max-w-11 transform rotate-180" src={SliderButton} alt='slide-left' />
          </div>
          
        </Swiper>
      </div>
    </React.Fragment>
  );
}

export default CarouselBanner